import React, { useEffect, useState, useRef } from 'react';
import { FaCarSide, FaSmileBeam, FaUserTie } from "react-icons/fa";
import { PiCertificateFill } from "react-icons/pi";
import "../styles/counter.css";
import { IoAddOutline } from "react-icons/io5";
import { GiCarKey } from "react-icons/gi";
import { FaCar } from "react-icons/fa";
import { BsTools } from "react-icons/bs";

const stats = [
  {
    icon: <PiCertificateFill size={40} />,
    count: 10,
    label: "YEARS OF EXPERIENCE",
    type: "plain",
  },
  {
    icon: <FaCar size={40} />,
    count: 500,
    label: "Available Cars",
    type: "cars",
  },
  {
    icon: <GiCarKey size={40} />,
    count: 1000,
    label: "SATISFIED CLIENTS",
    type: "clients",
  },
  {
    icon: <BsTools size={40} />,
    count: 10,
    label: "DEDICATED WORKERS",
    type: "workers",
  },
];

const Counter = () => {
  const countersRef = useRef(null);
  const [activated, setActivated] = useState(false);
  const duration = 3000;

  useEffect(() => {
    const handleScroll = () => {
      if (!countersRef.current) return;
      const containerTop = countersRef.current.offsetTop;
      const scrollTop = window.pageYOffset;

      if (scrollTop > containerTop - window.innerHeight + 100 && !activated) {
        setActivated(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [activated]);

  useEffect(() => {
    if (activated && countersRef.current) {
      const counters = countersRef.current.querySelectorAll("span[data-count]");

      counters.forEach(counter => {
        let count = 0;
        const target = parseInt(counter.dataset.count);
        const increment = target / (duration / 20);
        const update = () => {
          count += increment;
          if (count < target) {
            counter.innerText = Math.ceil(count).toLocaleString();
          } else {
            counter.innerText = target.toLocaleString();
            clearInterval(timer);
          }
        };
        const timer = setInterval(update, 20);
      });
    }
  }, [activated]);

  return (
    <div className="counter-section">
      <div className="counter-container" ref={countersRef}>
        {stats.map((item, idx) => (
          <div className="counter-box" key={idx}>
            <div className="icon">{item.icon}</div>
            <h2>
              <span data-count={item.count} data-type={item.type}>0</span>
                 <IoAddOutline className="plus-icon" />
             
            </h2>
            <p>{item.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Counter;
